import React from 'react';

import { ChipColor } from '@pkg/components/Sections/Profile/Chip';
import { ChipMember, type ChipMemberProps } from '@pkg/components/Sections/Profile/Chips/ChipMember';

import { ChipMemberWrapper } from './DepYatUsername.style';

export interface DepYatUsernameProps {
    yat?: ChipMemberProps['yat'];
    twitter?: ChipMemberProps['twitter'];
    to?: ChipMemberProps['to'];
    size?: ChipMemberProps['size'];
    hideTwitter?: boolean;
}

export function DepYatUsername({ yat, twitter, to, size, hideTwitter = false }: DepYatUsernameProps) {
    if (!yat) return null;

    return (
        <ChipMemberWrapper $clickable={Boolean(to?.length)}>
            <ChipMember
                yat={yat}
                twitter={hideTwitter ? undefined : twitter}
                to={to}
                size={size}
                color={ChipColor.BorderTransparent}
            />
        </ChipMemberWrapper>
    );
}
